import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';

import BackgroundImage from '../../../../components/BackgroundImage';
import Img from '../../../../components/Img';
import { getDefaultAvatar, getNameInitials } from '../../../../utils/collegeCorner';

import { defaultConferenceColumn, defaultDivisionColumn, defaultGenderColumn, defaultRankingColumn, defaultTableFilters, defaultUtrDoublesColumn, defaultUtrDoublesMaskedColumn, defaultUtrSinglesColumn, defaultUtrSinglesMaskedColumn, doublesUtrMaskedRating, doublesUtrRating, doublesUtrTitle, singlesUtrMaskedRating, singlesUtrRating, singlesUtrTitle, SORT_ORDER } from '../helpers';
import styles from './CollegeCornerCollegePlayers.scss';

export const initialTableFilters = {
    ...defaultTableFilters,
    sort: 'singlesUtr',
};

export const initialFilters = {
    ...initialTableFilters,
    gender: '',
    conference: '',
    division: '',
    sportTypes: { tennis: true },
    utrMin: null,
    utrMax: null,
    utrType: 'verified',
    utrTeamType: 'singles',
    utrReliability: null,
};

export const columns = [
    {
        ...defaultRankingColumn,
        maxWidth: 6,
        sortable: false,
        headerClassName: `${styles.rankingHead}`,
        rowClassName: `${styles.rankingCol}`,
        custom: (val, item, { rowIndex, total, order }) => {
            return order === SORT_ORDER.DESC ? rowIndex + 1 : total - rowIndex;
        },
    },
    {
        title: 'Player',
        sortable: false,
        key: 'lastName',
        maxWidth: 25,
        rowClassName: `${styles.playerCol}`,
        custom: (val, item) => {
            const nationalFlag = item?.source?.nationality
                ? `/img/flags/${item.source.nationality.toLowerCase()}.svg`
                : '';
            const playerName = item?.source?.displayName || '';
            return (
                <div className={`${styles.CollegeName}`}>
                    <div className={`${styles.displayLogo}`}>
                        {item?.source?.playerProfileImages?.default ? (
                                <BackgroundImage
                                    baseUrl={'/v1/player/'}
                                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                    images={item.source.playerProfileImages}
                                    imageType={'icon'}
                                    parentStylesClass={styles.profilePicture}
                                />
                        ) : (
                            <div className="avatar-placeholder border-grad-rad">
                                {getNameInitials(item.source)}
                            </div>
                        )}
                    </div>
                    <Link className="link" to={`/profiles/${item.id}`}>
                        {playerName}
                    </Link>
                    <div className={`${styles.nationalFlag}`}>
                        <Img
                            className="flag"
                            src={nationalFlag}
                            alt={item?.source?.nationality || ''}
                        />
                    </div>
                </div>
            );
        },
    },
    {
        ...defaultGenderColumn,
        maxWidth: 12,
        headerClassName: `${styles.genderHead}`,
        rowClassName: `${styles.genderCol}`,
        custom: (val, item) => item?.source?.gender || '',
    },
    {
        ...defaultUtrSinglesColumn,
        title: singlesUtrTitle(styles),
        headerClassName: `${styles.utrHead}`,
        rowClassName: `${styles.utrCol}`,
        custom: (val, item) => singlesUtrRating(val, item, styles),
    },
    {
        ...defaultUtrSinglesMaskedColumn,
        title: singlesUtrTitle(styles),
        headerClassName: `${styles.utrHead}`,
        rowClassName: `${styles.utrCol}`,
        custom: (val, item) => singlesUtrMaskedRating(val, item, styles),
    },
    {
        ...defaultUtrDoublesColumn,
        title: doublesUtrTitle(styles),
        headerClassName: `${styles.utrTwoHead}`,
        rowClassName: `${styles.utrTwoCol}`,
        custom: (val, item) => doublesUtrRating(val, item, styles),
    },
    {
        ...defaultUtrDoublesMaskedColumn,
        title: doublesUtrTitle(styles),
        headerClassName: `${styles.utrTwoHead}`,
        rowClassName: `${styles.utrTwoCol}`,
        custom: (val, item) => doublesUtrMaskedRating(val, item, styles),
    },
    {
        title: 'Year',
        maxWidth: 14,
        sortable: false,
        rowClassName: `${styles.gradYearCol}`,
        custom: (val, item) => {
            return item?.source?.playerCollegeDetails?.gradClassName
                ? item.source.playerCollegeDetails.gradClassName
                : '';
        },
    },
    {
        title: 'College',
        maxWidth: 20,
        sortable: false,
        rowClassName: `${styles.collegeCol}`,
        custom: (val, item) => {
            const gender = item?.source?.gender && item.source.gender;
            const menClubProfileImage = item?.source?.playerCollege?.mensClubProfilePhotoUrl && item.source.playerCollege.mensClubProfilePhotoUrl ? (
                <Img
                    src={`${'/v1/club/'}${item.source.playerCollege.mensClubProfilePhotoUrl
                        }`}
                    defaultimg={getDefaultAvatar(item.source.playerCollege)}
                    style={{ opacity: 1 }}
                />
            ) : (
                ''
            );
            const womenClubProfileImage = item?.source?.playerCollege?.womensClubProfilePhotoUrl && item.source.playerCollege.womensClubProfilePhotoUrl ? (
                <Img
                    src={`${'/v1/club/'}${item.source.playerCollege.womensClubProfilePhotoUrl
                        }`}
                    defaultimg={getDefaultAvatar(item.source.playerCollege)}
                    style={{ opacity: 1 }}
                />
            ) : (
                ''
            );
            const collegeName = item?.source?.playerCollege?.name || '';
            return (
                collegeName && (
                    <div className={`${styles.CollegeName}`}>
                        {((gender === 'Male' && menClubProfileImage) ||
                            (gender === 'Female' && womenClubProfileImage)) && (
                                <div className={`${styles.displayLogo}`}>
                                    {gender === 'Male' && menClubProfileImage}
                                    {gender === 'Female' && womenClubProfileImage}
                                </div>
                            )}
                        <div className={`${styles.detail}`}>
                            <Link
                                className="link"
                                to={`/colleges/${(gender === 'Male' &&
                                    item?.source?.playerCollege?.mensClubId) ||
                                    ''}${(gender === 'Female' &&
                                        item?.source?.playerCollege?.womensClubId) ||
                                    ''}`}
                            >
                                {collegeName}
                            </Link>
                            <div className={`${styles.gYear}`}>
                                {item?.source?.playerCollegeDetails?.gradYear
                                    ? moment(item.source.playerCollegeDetails.gradYear).format(
                                        'YYYY',
                                    )
                                    : ''}
                            </div>
                        </div>
                    </div>
                )
            );
        },
    },
    {
        ...defaultDivisionColumn,
        maxWidth: 15,
        rowClassName: `${styles.diviCol}`,
        custom: (val, item) => item?.source?.playerCollege?.conference?.division?.divisionName || '',
    },
    {
        ...defaultConferenceColumn,
        maxWidth: 18,
        rowClassName: `${styles.conCol}`,
        custom: (val, item) => item?.source?.playerCollege?.conference?.conferenceName || '',
    },
];
